import {EnvironmentProviders, importProvidersFrom, makeEnvironmentProviders} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

export function provideAviaryAnimations(): EnvironmentProviders {
  return makeEnvironmentProviders([
    // BrowserAnimationsModule is deprecated, but supported until Angular v23. Keep the deprecated API isolated here until we migrate away from it.
    importProvidersFrom(BrowserAnimationsModule)
  ]);
}
